import { gql } from '@apollo/client';
import React, { Component } from 'react';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import '../../../assets/scss/projectTable.scss';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _ from 'lodash';
import moment from 'moment';
import { subscribe } from 'graphql';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import constants from '../../../utils/constants';
import DataTableCompact from '../../components/DataTableCompact';
import HardDrivesSummary from './HardDriveSummary';
import { async } from 'q';

const getHardDrivesSummary = gql`
	query HddSummary($tenantIds: [String]) {
		hddSummary(tenantIds: $tenantIds) {
			all
			categoryFilters {
				category
				count
			}
			locationFilters {
				count
				location
			}
		}
	}
`;
const getHardDrivesList = gql`
	query VendorHardDriveList($workspaceId: String, $tenantIds: [String], $filters: HardDrivesDataInput) {
		vendorHardDriveList(workspaceId: $workspaceId, tenantIds: $tenantIds, filters: $filters) {
			totalDocs
			prevPage
			totalPages
			nextPage
			limit
			hasNextPage
			hasPrevPage
			currentPage
			data {
				createdBy
				id
				createdAt
				category
				location
				manufacturerId
				projectTitle
				qrCode
				status
				updatedAt
				updatedBy
				size
				responsibleUser
				responsibleUserId
				projectId
				manufacturer
				isPurchasedByClient
				projectSlNo
				tenantId
				branch {
					branchId
				}
			}
		}
		branchesList {
			branchId
			city
			address
			code
			description
			id
			state
		}
	}
`;
const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			displayName
		}
	}
`;
const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;
const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
class HardDrives extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			//change it to true after getting te harddrives list from the API
			isLoading: true,
			isVendorUsersLoading: true,
			hardDrivesList: [],
			hardDrivesSummary: [],
			limit: 20,
			sortBy: '',
			sortType: 0,
			page: 1,
			toggleColor: false,
			currentViewPage: 1,
			tenantUserList: [],
			isPageLoading: false,
			vendorUsers: [],
			categoryActiveFilter: '',
			searchWordFound: false,
			searchValue: '',

			branchIdsFilters: [],
			branchIdsActiveFilter: [],
			workspacesFilters: [],
			workspaceActiveFilter: [],
			workspaceFilterCleared: false,
			assignedToFilters: [],
			assignedToActiveFilter: '',
			officeclk2: false,
			outstationtclk2: false,
			userclk2: false,
			clientclk2: false,
			workingclk2: false,
			backupclk2: false,
			secureclk2: false,
			clientSearchFilter: '',
			locationsActiveFilter: '',
			locationsFilters: [
				{ key: 'inOffice', name: 'In Office' },
				{ key: 'client', name: 'Client' },
				{ key: 'employee', name: 'Employee' },
				{
					key: 'outStation',
					name: 'Outstation',
				},
			],
			categoryFilters: [
				{ key: 'working', name: 'Working' },
				{ key: 'backup', name: 'Backup' },
				{ key: 'secured', name: 'Secure' },
			],
			columns: [
				// { title: 'FLAG' },
				{ title: 'Qr Code' },
				{ title: 'Projects' },
				{ title: 'Type' },
				{ title: 'Size' },
				{ title: 'Location' },
				{ title: 'Branch' },
				// { title: 'Branch' },
				{ title: 'Assigned To' },
				{ title: 'Last Update By' },
				// { title: 'Sourced By' },
			],
			assignedToFilters: [],
		};
	}

	getActiveTenantIds = () => {
		// If user has selected specific workspaces, map workspaceId keys to _id
		if (_.size(this.state.workspaceActiveFilter) > 0) {
			return this.state.workspaceActiveFilter.map(wsId => {
				const ws = this.state.workspacesFilters.find(f => f.key === wsId);
				return ws?.workspaceid || wsId;
			});
		}
		// If user explicitly cleared, don't fall back to constants
		if (this.state.workspaceFilterCleared) return null;
		// Otherwise use vendor's activeWorkspaces from constants
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			return vendorConfig.activeWorkspaces.map(w => w._id);
		}
		return null;
	};

	timer = null;
	componentDidMount = () => {
		// Pre-select active workspaces from constants
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			this.setState({ workspaceActiveFilter: vendorConfig.activeWorkspaces.map(w => w.workspaceId) });
		}

		let json = {
			filters: {
				sortBy: 'updatedAt',
			},
		};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'searchedQuery') {
					json = {
						...json,
						filters: {
							...json.filters,

							search: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'location') {
					json = {
						...json,
						filters: {
							...json.filters,

							location: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'category') {
					json = {
						...json,
						filters: {
							...json.filters,

							category: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'assignedTo') {
					json = {
						...json,
						filters: {
							...json.filters,

							responsibleUserId: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'workspace') {
					const wsArr = subString[1].split(',');
					this.setState({
						workspaceActiveFilter: wsArr,
					});
				}
				if (subString[0] === 'page' || subString[0] === 'limit') {
					this.setState({
						[subString[0]]: parseInt(subString[1]),
					});
				}
				if (subString[0] === 'searchedQuery') {
					this.setState({
						searchValue: subString[1],
					});
				}
				if (subString[0] === 'location') {
					this.setState({
						locationsActiveFilter: subString[1],
					});
					if (subString[1] === 'inOffice') {
						this.setState({
							officeclk2: true,
						});
					} else if (subString[1] === 'client') {
						this.setState({
							clientclk2: true,
						});
					} else if (subString[1] === 'employee') {
						this.setState({
							userclk2: true,
						});
					} else if (subString[1] === 'outStation') {
						this.setState({
							outstationtclk2: true,
						});
					}
				}
				if (subString[0] === 'category') {
					this.setState({
						categoryActiveFilter: subString[1],
					});
					if (subString[1] === 'working') {
						this.setState({
							workingclk2: true,
						});
					} else if (subString[1] === 'backup') {
						this.setState({
							backupclk2: true,
						});
					} else if (subString[1] === 'secured') {
						this.setState({
							secureclk2: true,
						});
					}
				}
				if (subString[0] === 'assignedTo') {
					this.setState({
						assignedToActiveFilter: subString[1],
					});
				}
				count++;
			}
		} else {
			json = {
				...json,
				filters: {
					...json.filters,
					page: this.state.currentViewPage,
					limit: this.state.limit,
				},
			};
		}

		// Apply active workspaces as tenantIds
		const tenantIds = this.getActiveTenantIds();
		if (tenantIds) {
			json = { ...json, tenantIds };
		}

		const summaryVars = tenantIds ? { tenantIds } : {};
		this.getHardDrivesSummary(getHardDrivesSummary, summaryVars);

		this.getHardDrivesList(getHardDrivesList, json);
		this.getTenantUsers(getTenantUserList);

		this.getBranchList(getBranchList);
		this.getVendorsWorkspaces(
			getVendorInfo,
			{
				vendorId: this.props.params.vendorID,
			},
			'modify-object',
		);
	};

	componentWillUnmount = () => {
		if (this.timer) {
			clearTimeout(this.timer);
		}
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreHardDrives();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreHardDrives();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreHardDrives();
				},
			);
		}
	};
	fetchMoreHardDrives = async () => {
		const tenantIds = this.getActiveTenantIds();
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;
		if (_.size(this.state.branchIdsActiveFilter) > 0)
			queryString = `${queryString}&branchIds=${this.state.branchIdsActiveFilter.toString()}`;
		if (_.size(this.state.workspaceActiveFilter) > 0)
			queryString = `${queryString}&workspace=${this.state.workspaceActiveFilter.toString()}`;
		if (_.size(this.state.assignedToActiveFilter) > 0)
			queryString = `${queryString}&assignedTo=${this.state.assignedToActiveFilter.toString()}`;
		if (_.size(this.state.categoryActiveFilter) > 0)
			queryString = `${queryString}&category=${this.state.categoryActiveFilter.toString()}`;
		if (_.size(this.state.locationsActiveFilter) > 0)
			queryString = `${queryString}&location=${this.state.locationsActiveFilter.toString()}`;
		if (this.state.searchValue !== '')
			queryString = `${queryString}&searchedQuery=${this.state.searchValue.toString()}`;
		this.props.navigate(`/${this.props.params.vendorID}/harddrives${queryString}`);
		let filters = {
			filters: {
				sortBy: 'updatedAt',
				limit: this.state.limit,
				page: this.state.currentViewPage,
			},
		};
		if (_.size(this.state.assignedToActiveFilter) > 0)
			filters = {
				filters: {
					...filters.filters,
					responsibleUserId: this.state.assignedToActiveFilter,
				},
			};

		if (_.size(this.state.categoryActiveFilter) > 0)
			filters = {
				filters: {
					...filters.filters,
					category: this.state.categoryActiveFilter,
				},
			};
		if (_.size(this.state.locationsActiveFilter) > 0)
			filters = {
				filters: {
					...filters.filters,
					location: this.state.locationsActiveFilter,
				},
			};
		if (this.state.searchValue !== '') {
			filters = {
				filters: {
					...filters.filters,
					page: 1,
					search: this.state.searchValue,
				},
			};
		}
		if (_.size(this.state.branchIdsActiveFilter) > 0) {
			filters = {
				filters: {
					...filters.filters,
					branchIds: this.state.branchIdsActiveFilter,
				},
			};
		}
		if (tenantIds) {
			filters = {
				...filters,
				tenantIds,
			};
		}
		const summaryVars = tenantIds ? { tenantIds } : {};
		this.getHardDrivesSummary(getHardDrivesSummary, summaryVars);
		await this.getHardDrivesList(getHardDrivesList, filters);
	};
	getWorkspacekey = (name) => {
		if (this.state.workspacesFilters.length !== 0) {
			for (let i = 0; i < this.state.workspacesFilters.length; i++) {
				if (this.state.workspacesFilters[i].workspaceid === name) {
					return this.state.workspacesFilters[i].workspaceKey;
				}
			}
		}
		return ' ';
	};
	getAssignedToName = (assignedId) => {
		if (this.state.tenantUserList.length !== 0) {
			for (let i = 0; i < this.state.tenantUserList.length; i++) {
				if (this.state.tenantUserList[i].id === assignedId) {
					return (
						this.state.tenantUserList[i].firstName +
						' ' +
						this.state.tenantUserList[i].lastName
					);
				}
			}
		}

		return 'Unknown';
	};
	handleActiveFilter = async (e, type, key) => {
		let array;

		if (type === 'assignedTo') {
			array = key === this.state.assignedToActiveFilter ? '' : key;
		} else if (type === 'category') {
			array = key === this.state.categoryActiveFilter ? '' : key;
			if (key === 'working') {
				this.setState({
					workingclk2: !this.state.workingclk2,
				});
				if (this.state.backupclk2) {
					this.setState({
						backupclk2: false,
					});
				}
				if (this.state.secureclk2) {
					this.setState({
						secureclk2: false,
					});
				}
			} else if (key === 'backup') {
				this.setState({
					backupclk2: !this.state.backupclk2,
				});
				if (this.state.workingclk2) {
					this.setState({
						workingclk2: false,
					});
				}
				if (this.state.secureclk2) {
					this.setState({
						secureclk2: false,
					});
				}
			} else if (key === 'secured') {
				this.setState({
					secureclk2: !this.state.secureclk2,
				});
				if (this.state.backupclk2) {
					this.setState({
						backupclk2: false,
					});
				}
				if (this.state.workingclk2) {
					this.setState({
						workingclk2: false,
					});
				}
			} else if (key === '') {
				this.setState({
					backupclk2: false,
					workingclk2: false,
					secureclk2: false,
				});
			}
		} else if (type === 'locations') {
			array = key === this.state.locationsActiveFilter ? '' : key;
			if (key === 'inOffice') {
				this.setState({
					officeclk2: !this.state.officeclk2,
				});
				if (this.state.clientclk2) {
					this.setState({
						clientclk2: false,
					});
				}
				if (this.state.userclk2) {
					this.setState({
						userclk2: false,
					});
				}
				if (this.state.outstationtclk2) {
					this.setState({
						outstationtclk2: false,
					});
				}
			} else if (key === 'outStation') {
				this.setState({
					outstationtclk2: !this.state.outstationtclk2,
				});
				if (this.state.clientclk2) {
					this.setState({
						clientclk2: false,
					});
				}
				if (this.state.officeclk2) {
					this.setState({
						officeclk2: false,
					});
				}
				if (this.state.userclk2) {
					this.setState({
						userclk2: false,
					});
				}
			} else if (key === 'client') {
				this.setState({
					clientclk2: !this.state.clientclk2,
				});
				if (this.state.officeclk2) {
					this.setState({
						officeclk2: false,
					});
				}
				if (this.state.userclk2) {
					this.setState({
						userclk2: false,
					});
				}
				if (this.state.outstationtclk2) {
					this.setState({
						outstationtclk2: false,
					});
				}
			} else if (key === 'employee') {
				this.setState({
					userclk2: !this.state.userclk2,
				});
				if (this.state.officeclk2) {
					this.setState({
						officeclk2: false,
					});
				}
				if (this.state.clientclk2) {
					this.setState({
						clientclk2: false,
					});
				}
				if (this.state.outstationtclk2) {
					this.setState({
						outstationtclk2: false,
					});
				}
			} else if (key === '') {
				this.setState({
					outstationtclk2: false,
					clientclk2: false,
					officeclk2: false,
					userclk2: false,
				});
			}
		} else {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}

		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => {
				this.fetchMoreHardDrives();
			},
		);
	};
	applyFilter = (filter, type) => {
		if (type === 'category') {
			if (filter === 'working') {
				this.setState({
					workingclk2: !this.state.workingclk2,
				});
				if (this.state.backupclk2) {
					this.setState({
						backupclk2: false,
					});
				}
				if (this.state.secureclk2) {
					this.setState({
						secureclk2: false,
					});
				}
			} else if (filter === 'backup') {
				this.setState({
					backupclk2: !this.state.backupclk2,
				});
				if (this.state.workingclk2) {
					this.setState({
						workingclk2: false,
					});
				}
				if (this.state.secureclk2) {
					this.setState({
						secureclk2: false,
					});
				}
			} else if (filter === 'secured') {
				this.setState({
					secureclk2: !this.state.secureclk2,
				});
				if (this.state.backupclk2) {
					this.setState({
						backupclk2: false,
					});
				}
				if (this.state.workingclk2) {
					this.setState({
						workingclk2: false,
					});
				}
			} else if (filter === '') {
				this.setState({
					backupclk2: false,
					workingclk2: false,
					secureclk2: false,
				});
			}
		} else if (type === 'locations') {
			if (filter === 'inOffice') {
				this.setState({
					officeclk2: !this.state.officeclk2,
				});
				if (this.state.clientclk2) {
					this.setState({
						clientclk2: false,
					});
				}
				if (this.state.userclk2) {
					this.setState({
						userclk2: false,
					});
				}
				if (this.state.outstationtclk2) {
					this.setState({
						outstationtclk2: false,
					});
				}
			} else if (filter === 'outStation') {
				this.setState({
					outstationtclk2: !this.state.outstationtclk2,
				});
				if (this.state.clientclk2) {
					this.setState({
						clientclk2: false,
					});
				}
				if (this.state.officeclk2) {
					this.setState({
						officeclk2: false,
					});
				}
				if (this.state.userclk2) {
					this.setState({
						userclk2: false,
					});
				}
			} else if (filter === 'client') {
				this.setState({
					clientclk2: !this.state.clientclk2,
				});
				if (this.state.officeclk2) {
					this.setState({
						officeclk2: false,
					});
				}
				if (this.state.userclk2) {
					this.setState({
						userclk2: false,
					});
				}
				if (this.state.outstationtclk2) {
					this.setState({
						outstationtclk2: false,
					});
				}
			} else if (filter === 'employee') {
				this.setState({
					userclk2: !this.state.userclk2,
				});
				if (this.state.officeclk2) {
					this.setState({
						officeclk2: false,
					});
				}
				if (this.state.clientclk2) {
					this.setState({
						clientclk2: false,
					});
				}
				if (this.state.outstationtclk2) {
					this.setState({
						outstationtclk2: false,
					});
				}
			} else if (filter === '') {
				this.setState({
					outstationtclk2: false,
					clientclk2: false,
					officeclk2: false,
					userclk2: false,
				});
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				hardDrivesList: [],
				isPageLoading: true,
			},
			() => {
				this.fetchMoreHardDrives();
			},
		);
	};
	handleclearSelection = (e, type) => {
		if (type === 'category') {
			this.setState({
				backupclk2: false,
				workingclk2: false,
				secureclk2: false,
			});
		} else if (type === 'locations') {
			this.setState({
				outstationtclk2: false,
				clientclk2: false,
				officeclk2: false,
				userclk2: false,
			});
		}
		const stateUpdate = {
			[`${type}ActiveFilter`]: type === 'assignedTo' ? '' : [],
			currentViewPage: 1,
			isPageLoading: true,
		};
		if (type === 'workspace') {
			stateUpdate.workspaceFilterCleared = true;
		}
		this.setState(stateUpdate, () => this.fetchMoreHardDrives());
	};
	handleSearch = (e) => {
		this.setState(
			{
				searchValue: e.target.value.trimStart(),
			},
			() => {
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.fetchMoreHardDrives();
				}, 400);
			},
		);
	};

	render() {
		return (
			<div>
				<div className="layout-wrapper">
					{this.state.isLoading ? (
						<>
							<LoadingBar />
						</>
					) : (
						<div className="container">
							<div className="searchContainer">
								<a className="title">Hard Drives</a>
								<div className="searchWrapper">
									<div className="search-inner-left">
										<span className="search-icon">
											<SearchIcon />
										</span>
										<input
											placeholder="Search Client"
											// name={this.state.searchType}
											value={this.state.searchValue}
											onChange={(event) => this.handleSearch(event)}
										/>
									</div>
									<div className="search-inner-right">
										<span
											className="search-dropdown-btn"
											style={{ position: 'relative' }}
										>
											<a className="search-type">
												{/* <b
                                                    className={
                                                        this.state
                                                            .showSearchDropDown
                                                            ? 'invert'
                                                            : ''
                                                    }
                                                > */}
												<p
													style={{
														paddingRight: '20px',
													}}
													// onClick={
													//     this
													//         .handleSearchClick
													// }
												>
													Search
												</p>
												{/* </b> */}
											</a>
										</span>
									</div>
								</div>
								<div
									className="create-shoot-btn"
									onClick={() => {
										this.props.navigate(
											`/${this.props.params.vendorID}/harddrives/assign`,
										);
									}}
								>
									Assign HD
								</div>
								<div
									className="create-shoot-btn"
									onClick={() => {
										this.props.navigate(
											`/${this.props.params.vendorID}/harddrives/receive`,
										);
									}}
								>
									Receive HD
								</div>
							</div>
							<div className="filters">
								{/* <Filter
									type={'branchIds'}
									label={'Branch Id'}
									filters={this.state.branchIdsFilters}
									activeFilter={this.state.branchIdsActiveFilter}
									handleActiveFilter={(e, type, key) =>
										this.handleActiveFilter(e, 'branchIds', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'branchIds')
									}
									isMultipleSelectable={true}
									
								/> */}
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									version="v2"
									filters={this.state.workspacesFilters}
									activeFilter={this.state.workspaceActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'workspace', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'workspace')
									}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'locations'}
									label={'Locations'}
									filters={this.state.locationsFilters}
									activeFilter={this.state.locationsActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'locations', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'locations')
									}
									isMultipleSelectable={false}
									filterType="shoot"
									version="v2"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'category'}
									label={'Types'}
									filters={this.state.categoryFilters}
									activeFilter={this.state.categoryActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'category', key)
									}
									clearSelection={(e) => this.handleclearSelection(e, 'category')}
									isMultipleSelectable={false}
									filterType="shoot"
									version="v2"
									applyFilter={this.applyFilter}
								/>
								{/* <Filter
                                    key={this.state.isVendorUsersLoading}
                                    type={'assignedTo'}
                                    label={'Assigned To'}
                                    filters={this.state.assignedToFilters}
                                    activeFilter={
                                        _.size(this.state.assignedToFilters) > 0
                                            ? this.state.assignedToActiveFilter
                                            : ''
                                    }
                                    handleActiveFilter={(e, status, key) =>
                                        this.handleActiveFilter(
                                            e,
                                            'assignedTo',
                                            key
                                        )
                                    }
                                    clearSelection={(e) =>
                                        this.handleclearSelection(
                                            e,
                                            'assignedTo'
                                        )
                                    }
                                    isMultipleSelectable={false}
                                    filterType="shoot"
                                /> */}
								{this.state.isVendorUsersLoading ? (
									''
								) : (
									<Filter
										type={'assignedTo'}
										label={'Assigned To'}
										filters={this.state.assignedToFilters}
										activeFilter={this.state.assignedToActiveFilter}
										handleActiveFilter={(e, status, key) =>
											this.handleActiveFilter(e, 'assignedTo', key)
										}
										clearSelection={(e) =>
											this.handleclearSelection(e, 'assignedTo')
										}
										isMultipleSelectable={false}
										filterType="shoot"
										version="v2"
										applyFilter={this.applyFilter}
									/>
								)}
							</div>
							<div className={'table hd-list-table'}>
								<div
									className="tablesection"
									style={{
										// marginLeft: '40px',
										// marginTop: '40px',

										display: 'flex',
										gap: '10px',
									}}
								>
									<HardDrivesSummary
										officeclk2={this.state.officeclk2}
										userclk2={this.state.userclk2}
										clientclk2={this.state.clientclk2}
										workingclk2={this.state.workingclk2}
										backupclk2={this.state.backupclk2}
										secureclk2={this.state.secureclk2}
										outstationtclk2={this.state.outstationtclk2}
										handleActiveFilter={this.handleActiveFilter}
										handleclearSelection={this.handleclearSelection}
										data={this.state.hardDrivesSummary}
									/>
									{/* <div>

                                    </div> */}

									<DataTableCompact
										ptProps="yes"
										tableHeaderLeftPad={35}
										isLoading={this.state.isLoading}
										// tableHeader={`${this.state.mainFilter} PROJECTS`}
										columns={this.state.columns}
										// activeSortType={this.state.sortType}
										// activeSortBy={this.state.sortBy}
										//handleSort={this.handleProjectSort}
										isPageLoading={this.state.isPageLoading}
										limit={this.state.limit}
										totalPages={this.state.totalPages}
										currentViewPage={this.state.currentViewPage}
										lengthOfList={this.state.lengthOfList}
										onClickNextPage={this.onClickNextPage}
										onClickPreviousPage={this.onClickPreviousPage}
										dataList={this.state.hardDrivesList.data}
										goToPage={(e) => this.handleGoToPage(e)}
										// module={'project'}
										searchQuery={''}
										mainFilter={''}
									>
										{_.size(this.state.hardDrivesList.data) !== 0 &&
											this.state.hardDrivesList.data.map((hd, i) => {
												return (
													<tr
														style={{
															// marginTop:
															//     '40px',
															fontSize: '14px',
														}}
														onClick={() => {
															this.props.navigate(
																`/${this.props.params.vendorID}/harddrives/${hd.qrCode}`,
															);
														}}
													>
														<td>
															<div
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '8px',
																	color: 'white',
																}}
															>
																<p>{hd.qrCode}</p>
																<p
																	style={{
																		color: '#707070',
																		textTransform: 'uppercase',
																	}}
																>
																	{hd.manufacturerId}
																</p>
															</div>
														</td>

														<td>
															<div
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '8px',
																	color: 'white',
																}}
															>
																<p>{hd.projectTitle}</p>
																<p
																	style={{
																		color: '#707070',
																	}}
																>
																	{this.getWorkspacekey(
																		hd.tenantId,
																	) + '-'}
																	{hd.projectSlNo}
																</p>
															</div>
														</td>
														<td>
															{/* {hd.category} */}
															<span
																className={`completed-shoots `}
																style={{
																	// marginTop: '-120px',

																	display: 'flex',
																	// justifyContent: 'flex-start',
																	alignItems: 'center',
																	textTransform: 'uppercase',
																	fontSize: '14px',
																}}
															>
																<b
																	style={{
																		width: '10px',
																		height: '10px',
																		minHeight: '10px',
																		minWidth: '10px',
																		borderRadius: '2px',
																		backgroundColor:
																			hd.category ===
																			'working'
																				? '#03A0FF'
																				: hd.category ===
																				  'backup'
																				? '#FE2C2B'
																				: '#7B7B7B',
																		marginRight: 5,
																		display: 'flex',
																	}}
																></b>
																{hd.category === 'working'
																	? 'WORKING'
																	: hd.category === 'backup'
																	? 'BACKUP'
																	: 'SECURE'}
																{/* <p>{this.props.data.status}</p> */}
															</span>
														</td>
														<td>{hd.size} TB</td>
														<td>
															{hd.location.charAt(0).toUpperCase() +
																hd.location
																	.replace(/([A-Z])/g, ' $1')
																	.slice(1)}
															{/* {hd.location} */}
														</td>
														<td>
															{hd.branch ? hd.branch.branchId : ''}
															{/* {hd.location} */}
														</td>
														<td
															style={{
																backgroundColor:
																	hd.location !== 'inOffice' &&
																	hd.location !== 'client' &&
																	hd.responsibleUser
																		? '#242424'
																		: '',
															}}
														>
															{!_.has(hd, 'responsibleUser') ||
															(_.has(hd, 'responsibleUser') &&
																hd.responsibleUser === null) ||
															hd.location === 'inOffice' ||
															hd.location === 'client' ? null : (
																<div
																	style={{
																		display: 'flex',
																		flexDirection: 'column',
																		gap: '8px',
																		color: 'white',
																	}}
																>
																	<p>
																		{hd.responsibleUser
																			? hd.responsibleUser
																			: '-'}
																	</p>
																	<p
																		style={{
																			color: '#707070',
																		}}
																	>
																		{moment
																			.unix(hd.updatedAt)
																			.fromNow()}
																	</p>
																</div>
															)}
														</td>

														<td>
															<div
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '8px',
																	color: 'white',
																}}
															>
																<p>
																	{this.state.tenantUserList
																		.length > 0 &&
																		this.getAssignedToName(
																			hd.updatedBy,
																		)}
																</p>
																<p
																	style={{
																		color: '#707070',
																	}}
																>
																	{moment
																		.unix(hd.updatedAt)
																		.fromNow()}
																</p>
															</div>
														</td>
													</tr>
												);
											})}
									</DataTableCompact>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}
export default withRouter(HardDrives);
